import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";

const { item } = routes;

/**
 * The item-viewer area's route tree: each registry node paired with its read-only
 * detail page.
 *
 * Legacy `/item/*` deeplinks are normalised to these canonical `/items/*` paths on
 * ingestion; in-app cards still targeting `/item/*` redirect here (routes.tsx).
 *
 * Each page wraps itself in <ItemItineraryGuard>, since an item is looked up in
 * the selected itinerary and a deeplink may target one that isn't selected yet.
 */
export const itemRoutes: RouteRender[] = [
  lazyView(
    item.flight,
    () => import("./flights/items-flights").then((m) => ({ default: m.ItemsFlightsPage })),
    "Flight",
  ),
  lazyView(item.todo, () => import("./todos/items-todos").then((m) => ({ default: m.ItemsTodosPage })), "To Do"),
  lazyView(
    item.activity,
    () => import("./activities/items-activities").then((m) => ({ default: m.ItemsActivitiesPage })),
    "Activity",
  ),
  lazyView(item.hotel, () => import("./hotels/items-hotels").then((m) => ({ default: m.ItemsHotelsPage })), "Hotel"),
  lazyView(
    item.hireCar,
    () => import("./hire-cars/items-hire-cars").then((m) => ({ default: m.ItemsHireCarsPage })),
    "Hire Car",
  ),
  lazyView(
    item.transport,
    () => import("./transport/items-transport").then((m) => ({ default: m.ItemsTransportPage })),
    "Transport",
  ),
  lazyView(
    item.parking,
    () => import("./parking/items-parking").then((m) => ({ default: m.ItemsParkingPage })),
    "Parking",
  ),
];
